import { useCallback, useMemo, useState } from 'react';

export const useAnalyticsDataInitialiser = () => {
  const [lastUpdatedTimestamp, setTimestamp] = useState();

  const updateTimestamp = useCallback(
    () => setTimestamp(Number(new Date())),
    []
  );

  const returnValue = useMemo(
    () => [lastUpdatedTimestamp, updateTimestamp],
    [lastUpdatedTimestamp]
  );

  return returnValue;
};
